'use client';

import { createContext } from 'react';

import type { ShowHideRootContextInterface } from '../types/show-hide-root.types';

export const ShowHideRootContext = createContext<ShowHideRootContextInterface>({
  setIsHidden: () => {},
});

ShowHideRootContext.displayName = 'ShowHide.Root.Context';
